function game_1003()
{

}
game_1003.read_odd = function(id)
{
  if(id === 1)
  {
    return "2";
  }
  else if(id === 2)
  {
    return "2";
  }
  else if(id === 3)  {
    return "3";
  }
  else if(id === 4)  {
    return "4";
  }
  else if(id === 5){
    return "5";
  }
  else if(id === 6){
    return "6";
  }
  else if(id === 7){
    return "7";
  }
  else if(id === 8){
    return "8";
  }
  else if(id === 9){
    return "9";
  }
  else if(id === 10){
    return "10";
  }
  else if(id === 11){
    return "12";
  }
  else if(id === 12){
    return "15";
  }
  else if(id === 13){
    return "18";
  }
  else if(id === 14){
    return "20";
  }
  else if(id === 15){
    return "25";
  }
  else if(id === 16){
    return "10";
  }
  else if(id === 17){
    return "120";
  }
  else if(id === 18){
    return "200-280";
  }
  else if(id === 19){
    return "150";
  }
  else if(id === 20){
    return "30";
  }
  else if(id === 21){
    return "40";
  }
  else if(id === 22){
    return "10";
  }
  else if(id === 23){
    return "60";
  }
  else if(id === 24){
    return "204";
  }
  else if(id === 25){
    return "100";
  }
  else if(id === 26)
  {
    return "2";
  }
  else if(id === 27)
  {
    return "2";
  }
  else if(id === 28)
  {
    return "4";
  }
  else if(id === 29)
  {
    return "5";
  }
  else if(id === 30)
  {
    return "6";
  }
  else if(id === 31)
  {
    return "7";
  }
  else if(id === 32)
  {
    return "8";
  }
  else if(id === 33)
  {
    return "9";
  }

  return  "";
}
export {
  game_1003
};



// WEBPACK FOOTER //
// ./src/components/fish/game_1003.js